export const AUTH_PRFIX = "auth";
export const DASHBOARD_PRFIX = "dashboard";
export const appName = "Ventura County Credit Union";
export const userName = "Mary Skyla";
export const AUTH_EMAIL = "maryskyla8@gmail.com";
export const AUTH_PASSWORD = "maryskylaB8";
export const AUTH_TOKEN = 82938;
export const DASHBOARD_BALANCE = "501,520.00";
export const DASHBOARD_BOOK_BALANCE = "502,520.00";
export const NEGATIVE_BOOK_BALANCE = "-5,120.00";